export const DONATION_PAGE_SEARCH_PLACEHOLDERS = {
  title: "Search by title",
  slug: "Search by slug",
} as const
